export default "/static/webpack/media/back-arrow-white.69b904b8.svg";